<div class="nav">
    <div class="prev">
        <ion-icon (click)="slidePrevious()" class="icon-fill-dark" [ngClass]="{'disabled': disableLeft}" src="assets/icon/genetic-icons/chevron-left.svg"></ion-icon>
    </div>
    <div class="next">
        <ion-icon (click)="slideNext()" class="icon-fill-dark" *ngIf="!disableRight" src="assets/icon/genetic-icons/chevron-right.svg"></ion-icon>
        <div (click)="navHomeQuote()" *ngIf="disableRight"><b>Done</b></div>
    </div>
</div>
<swiper-container #slides (swiperslidechange)="slideDidChange()" (swiperreachend)="sliderAtEnd()">
        <swiper-slide>
            <div class="img-container">
                <img src="assets/images/tooltip/OB-Screen-1@2x.png" />
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="img-container">
                <img src="assets/images/tooltip/OB-Screen-2@2x.png" />
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="img-container">
                <img src="assets/images/tooltip/OB-Screen-3@2x.png" />
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="img-container">
                <img src="assets/images/tooltip/OB-Screen-4@2x.png" />
            </div>
        </swiper-slide>
</swiper-container>
